import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

import Tooltip from "@mui/material/Tooltip";
import ErrorIcon from "@mui/icons-material/Error";
import { red } from "@mui/material/colors";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import { getLocalizedCountryName, getAllCountryCodesLowerCase, getDialCodeByCountryCode } from "@routebot/constants";
import QuestionIcon from "@mui/icons-material/HelpOutline";
import tr from "react-phone-input-2/lang/tr.json";

const PhoneNumberInput = ({
  id,
  label,
  phoneNumber,
  countryCode,
  errorText,
  dontShowError = false,
  language,
  isEmptyAllowed = true,
  onChange,
  hideLabel = false,
  style = {},
  description,
}) => {
  const [isValid, setIsValid] = useState(null);

  const getInitialValidity = (phoneNumber, countryCode, isEmptyAllowed) => {
    const isEmpty = !phoneNumber || phoneNumber === countryCode || phoneNumber === "+" + countryCode;
    if (isEmptyAllowed && isEmpty) return true;
    if (!isEmpty) {
      if (countryCode.toUpperCase() === "TR") {
        return isPossiblePhoneNumber("+90" + phoneNumber);
      }
      return isPossiblePhoneNumber(phoneNumber);
    }
    return false;
  };

  const handleChange = (value, data) => {
    const isEmpty = value === data.dialCode;
    const phoneNumberValueToValidate = isEmpty ? "" : "+" + value;
    const isValid = (isEmptyAllowed && isEmpty) || (!isEmpty && isPossiblePhoneNumber(phoneNumberValueToValidate));
    setIsValid(isValid);
    if (isEmpty && isEmptyAllowed) {
      onChange("", data.countryCode.toUpperCase(), true);
      return;
    }
    if (data.countryCode.toUpperCase() === "TR") {
      onChange(value.substring(2), data.countryCode.toUpperCase(), isValid);
    } else {
      onChange("+" + value, data.countryCode.toUpperCase(), isValid);
    }
  };

  useEffect(() => {
    const initialValidity = getInitialValidity(phoneNumber, countryCode, isEmptyAllowed);
    setIsValid(initialValidity);
  }, [phoneNumber, countryCode, isEmptyAllowed]);

  return (
    <div className={`generic-input ${!isValid && "generic-input--invalid"}`} style={{ ...style }}>
      {label && (
        <label
          htmlFor={id}
          style={{
            whiteSpace: "pre-wrap",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            columnGap: "10px",
          }}
        >
          {label}

          {description && (
            <Tooltip title={<span style={{ whiteSpace: "pre-line" }}>{description}</span>}>
              <QuestionIcon sx={{ color: "gray", width: "20px", height: "auto" }} />
            </Tooltip>
          )}
          {isValid === false && !dontShowError && (
            <Tooltip title={errorText || "Geçersiz telefon numarası"}>
              <ErrorIcon
                sx={{ color: red[800], width: "22px", height: "auto", marginLeft: "5px" }}
                className="blinking"
              />
            </Tooltip>
          )}
        </label>
      )}
      <PhoneInput
        key={`phoneinput-${countryCode}-${language}`}
        localization={language === "tr" ? tr : undefined}
        inputProps={{
          name: id,
          //   onBlur: touchHandler,
          autoComplete: "off",
        }}
        onlyCountries={getAllCountryCodesLowerCase()}
        country={countryCode.toLowerCase()}
        //preferredCountries={props.preferredCountries || ["tr"]}
        value={
          countryCode === "TR"
            ? "+90" + phoneNumber
            : phoneNumber === ""
            ? getDialCodeByCountryCode(countryCode)
            : phoneNumber
        }
        onChange={handleChange}
        enableSearch
        inputStyle={{ width: "100%" }}
        countryCodeEditable={false}
        specialLabel={hideLabel ? "" : getLocalizedCountryName(countryCode.toLowerCase()) || ""}
        searchPlaceholder={language === "tr" ? "Ülke ara..." : "Search country..."}
        searchNotFound={language === "tr" ? "Ülke bulunamadı" : "Country not found"}
      />
    </div>
  );
};

export default PhoneNumberInput;
